import React, { useState } from "react";
import "./RangeSlider.css";
const RangeSlider = () => {
  const [sliderValue, setSliderValue] = useState(182);

  const handleChange = (event) => {
    setSliderValue(event.target.value);
  };

  return (
    <div className="text-res-normal font-semibold pb-[36px]">
      <div className="text-center mb-[20px]">{sliderValue}</div>
      <div className="flex items-center justify-center">
        <div className="pr-[9px]">
          <span>1</span>
        </div>
        <input
          type="range"
          min="1"
          max="365"
          value={sliderValue}
          onChange={handleChange}
          className="appearance-none w-[150px] md:w-[302px] h-2 rounded-full slider-thumb-color bg-main-black"
          style={{
            "--thumb-color": "black",
            "--thumb-border-color": "white",
          }}
        />
        <div className="pl-[13px]">
          <span>365</span>
        </div>
      </div>
    </div>
  );
};

export default RangeSlider;
